import Component from './post_grid_item.vue'
export default Component
